import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة الغياب للمادة";
const DESCRIPTION = "احسب نسبة الغياب المسموح بها للمادة";
const KEYWORDS =
  "حاسبة غياب، نسبة غياب، غياب دراسي، حساب غياب، أيام غياب مسموحة، جدول دراسي، فصول دراسية، تقدير دراسي، نجاح دراسي، طلاب، جامعات، مدارس، تعليم، حساب نسبة الغياب، برنامج حساب نسبة الغياب، حساب الغياب، حساب ساعات الغياب";
const OG_URL = "https://do-calculate.com/calculator/ar/absence-calculator/";
function AbsenceCalculator() {
  const [numDays, setNumDays] = useState(1);
  const [hoursPerDay, setHoursPerDay] = useState([""]);
  const [numSemesters, setNumSemesters] = useState(16);
  const [allowedAbsence, setAllowedAbsence] = useState(10);
  const [totalHours, setTotalHours] = useState(0);
  const [allowedAbsenceHours, setAllowedAbsenceHours] = useState(0);
  const [estimatedAbsenceDays, setEstimatedAbsenceDays] = useState(0);
  const [error, setError] = useState("");
  const handleNumDaysChange = (e) => {
    const days = parseInt(e.target.value);
    setNumDays(days);
    setHoursPerDay(Array(days).fill(""));
  };
  const handleHoursPerDayChange = (index, value) => {
    const newHoursPerDay = [...hoursPerDay];
    newHoursPerDay[index] = value;
    setHoursPerDay(newHoursPerDay);
  };
  const handleCalculate = () => {
    try {
      const totalHoursPerWeek = hoursPerDay.reduce(
        (acc, curr) => acc + parseFloat(curr || 0),
        0
      );
      const totalHours = totalHoursPerWeek * numSemesters;
      const allowedAbsenceHours = (totalHours * allowedAbsence) / 100;
      const averageHoursPerDay = totalHoursPerWeek / numDays;
      const estimatedAbsenceDays = allowedAbsenceHours / averageHoursPerDay;
      setTotalHours(totalHours);
      setAllowedAbsenceHours(allowedAbsenceHours);
      setEstimatedAbsenceDays(estimatedAbsenceDays.toFixed(2));
      setError("");
    } catch (error) {
      setError("حدث خطأ أثناء الحساب. الرجاء التحقق من المدخلات.");
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  احصل على حساب دقيق لنسبة الغياب المسموح بها في دراستك بكل
                  سهولة! هذه الأداة الذكية مصممة لمساعدتك في تحديد عدد الحصص
                  التي يمكنك غيابها دون التأثير على تقديرك النهائي.
                </p>{" "}
                <p>ما عليك سوى إدخال المعلومات التالية:</p>
                <ul>
                  <li>
                    عدد أيام الدراسة في الأسبوع: سواء كنت تدرس خمسة أيام أو
                    أكثر، ستجد الحاسبة قادرة على التعامل مع جميع الجداول
                    الدراسية.
                  </li>
                  <li>
                    عدد الساعات الدراسية اليومية: حدد المدة الزمنية لكل حصة
                    دراسية لتحديد إجمالي ساعات الدراسة الأسبوعية.
                  </li>
                  <li>
                    عدد الفصول الدراسية: سواء كنت في فصل دراسي واحد أو أكثر،
                    ستحصل على نتيجة دقيقة تناسب حالتك.
                  </li>
                  <li>
                    نسبة الغياب المسموح بها: حدد النسبة المئوية للغياب التي تسمح
                    بها مؤسستك التعليمية للحصول على حساب دقيق.
                  </li>
                </ul>
                <p>لماذا تستخدم هذه الحاسبة؟</p>
                <ul>
                  <li>
                    تخطيط أفضل: خطط لغيابك المدرسي بوعي وبناءً على حسابات دقيقة.
                  </li>
                  <li>
                    تجنب المشاكل الأكاديمية: تأكد من أن نسبة غيابك ضمن الحدود
                    المسموح بها لتجنب أي انعكاسات سلبية على تقديرك.
                  </li>
                  <li>
                    راحة البال: احصل على إجابة واضحة وسريعة حول نسبة الغياب
                    المسموح بها.
                  </li>
                </ul>
                <hr />
              </div>
              <br />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="numDays">
                          عدد أيام المادة في الأسبوع
                        </label>
                      </b>
                      <select
                        id="numDays"
                        className="form-control"
                        value={numDays}
                        onChange={handleNumDaysChange}
                        style={{ width: "75%" }}
                      >
                        <option value={1}>يوم واحد</option>
                        <option value={2}>يومين</option>
                        <option value={3}>ثلاثة أيام</option>
                      </select>
                    </div>
                    {hoursPerDay.map((_, index) => (
                      <div
                        key={index}
                        className="form-group d-flex align-items-center"
                      >
                        <b>
                          <label className="form-label ms-2">
                            أدخل عدد الساعات لليوم {index + 1}
                          </label>
                        </b>
                        <input
                          type="number"
                          value={hoursPerDay[index]}
                          onChange={(e) =>
                            handleHoursPerDayChange(index, e.target.value)
                          }
                          placeholder="أدخل عدد الساعات"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                      </div>
                    ))}
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="semesters">
                          عدد الفصول الدراسية
                        </label>
                      </b>
                      <select
                        id="semesters"
                        className="form-control"
                        value={numSemesters}
                        onChange={(e) =>
                          setNumSemesters(parseInt(e.target.value))
                        }
                        style={{ width: "75%" }}
                      >
                        <option value={16}>فصلين (16 أسبوع)</option>
                        <option value={12}>ثلاثة فصول (12 أسبوع)</option>
                      </select>
                    </div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="absence">
                          نسبة الغياب المسموح بها
                        </label>
                      </b>
                      <select
                        id="absence"
                        className="form-control"
                        value={allowedAbsence}
                        onChange={(e) =>
                          setAllowedAbsence(parseInt(e.target.value))
                        }
                        style={{ width: "75%" }}
                      >
                        <option value={10}>10%</option>
                        <option value={15}>15%</option>
                        <option value={20}>20%</option>
                        <option value={25}>25%</option>
                        <option value={30}>30%</option>
                        <option value={35}>35%</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {totalHours > 0 &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <p>إجمالي عدد الساعات: {totalHours}</p>
                      <p>عدد الساعات المسموح بالغياب: {allowedAbsenceHours}</p>
                      <p>
                        تقدير عدد الأيام المسموح بها للغياب:{" "}
                        {estimatedAbsenceDays} يوم
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">معلومات إضافية</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>كيفية الاستخدام </h2>
                  </u>
                  <p>
                    للاستفادة القصوى من هذه الحاسبة، يُرجى إدخال البيانات بدقة.
                  </p>
                  <div className="p-3 mb-2 bg-info">
                    مثال: إذا كانت المادة تُدرس 3 أيام في الأسبوع، أدخل عدد
                    الساعات لكل يوم.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>نصائح لاحتساب الغياب</h2>
                  </u>
                  <p>
                    يجب مراعاة أيام الغياب المسموح بها حسب النسبة المئوية
                    المختارة.
                  </p>
                  <ul>
                    <li>تأكد من دقة الساعات المدخلة.</li>
                    <li>اختر النسبة المئوية المناسبة.</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    النسبة المئوية للغياب تحدد عدد الساعات المسموح بالغياب.
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>أسئلة متكررة</h2>
                  </u>
                  <p>كيف يمكن حساب الغياب؟</p>
                  <ul>
                    <li>تحديد عدد الأيام وعدد الساعات لكل يوم.</li>
                    <li>اختيار عدد الفصول الدراسية.</li>
                    <li>اختيار نسبة الغياب المسموح بها.</li>
                  </ul>
                  <p>
                    يتم حساب إجمالي الساعات المسموح بها للغياب بناءً على
                    المدخلات.
                  </p>
                  <b>مثال</b>
                  <div className="p-3 mb-2 bg-info text-black">
                    في حال كانت المادة تُدرس ليومين في الأسبوع، مع 3 ساعات لكل
                    يوم، يتم الحساب بناءً على عدد الأسابيع والفصول.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default AbsenceCalculator;
